import React from "react";

export default class SectionLoadingError extends React.Component {
    render() {
        const { sectionErrorClass, headerClass, bodyClass, title, titleIcon, message, messageIcon, children } = this.props;
        var bodyIcon = messageIcon ? messageIcon : "icon-info";

        return (
            <div className={"section-error-container " + (sectionErrorClass ? sectionErrorClass : "")}>
                <div className="row">
                    <div className="col-12 align-self-center">
                        {(title || titleIcon) &&
                            <div className={"row section-error__header " + (headerClass ? headerClass : "")}>
                                <div className="col-12">
                                    <div className="section-error__header--title">
                                        {titleIcon && <span className={titleIcon} />}
                                        {title && <span className="title-text">{title}</span>}
                                    </div>
                                </div>
                            </div>
                        }
                        {(message || children) &&
                            <div className={"row section-error__body " + (bodyClass ? bodyClass : "")}>
                                <div className="col-12">
                                    {children
                                        ? <div className="section-error__body--message">
                                            {children}
                                        </div>
                                        : <div className="section-error__body--message">
                                            {bodyIcon !== '' && <span className={bodyIcon} />}
                                            <span className="message-text">{message !== '' ? message : 'Failed to load. Please try again.'}</span>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}